import turfUnion from "@turf/union";
import { featureCollection } from '@turf/helpers';

export default function union(feature1, feature2) {
    //create a collection of the two features
    // var collection = featureCollection([feature1,feature2]);

    return turfUnion(feature1, feature2);
};
